import classNames from 'classnames';
import {ReactNode, useState} from 'react';

import {Question} from '@/components/common/faq/Question';

import styles from './FAQ.module.css';

export type QuestionType = {
	question: string;
	answer: string | ReactNode;
};

interface FAQProps {
	questions: QuestionType[];
	withSeparator?: boolean;
	className?: string;
	questionRootClassName?: string;
	questionClassName?: string;
	answerClassName?: string;
	classNameAnswerHeight?: string;
}

export function FAQ({
	questions,
	withSeparator = false,
	className,
	questionRootClassName,
	questionClassName,
	answerClassName,
	classNameAnswerHeight,
}: FAQProps) {
	const [variable, setVariable] = useState(0);

	setTimeout(() => {
		setVariable(variable + 1);
	}, 1000);

	return (
		<ul className={classNames(styles.root, className)} itemScope itemType="https://schema.org/FAQPage">
			{questions.map(({question, answer}, id) => (
				<li className={styles.item} key={question} itemScope>
					<Question
						key={id}
						question={question}
						answer={answer}
						withSeparator={withSeparator}
						className={questionRootClassName}
						questionClassName={questionClassName}
						answerClassName={answerClassName}
						answerHeightClassName={classNames(styles.answerHeight, classNameAnswerHeight)}
						withMicroData={true}
					/>
				</li>
			))}
		</ul>
	);
}
